/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Icon } from 'sarsaparilla';
import uniqBy from 'lodash/uniqBy';
import { parseDate } from 'ui-activitypass/src/utils/date_time_utils';
import { today } from '@internationalized/date';
import { getPrice } from '../utils';
import { PassTypeProps } from '../props';

export default class PassRateTable extends Component {
    static defaultProps = {
        passTypes: [],
        sortFn: (a, b) =>
            parseFloat(getPrice(b.periods).replace(/\/.*|\D/g, ' ')) -
            parseFloat(getPrice(a.periods).replace(/\/.*|\D/g, ' ')),
    };

    static propTypes = {
        passTypes: PropTypes.arrayOf(PassTypeProps),
        sortFn: PropTypes.func,
    };

    state = {
        isOpen: false,
    };

    toggleOpen = () => this.setState(({ isOpen }) => ({ isOpen: !isOpen }));

    render() {
        const { passTypes } = this.props;
        const { isOpen } = this.state;
        const periods = passTypes
            .flatMap((passType) => passType.periods)
            .filter((i) => i)
            .filter((i) => today().compare(parseDate(i.start_date)) < 0);
        const startDates = uniqBy(periods, 'start_date')
            .map(({ start_date: start }) => start)
            .sort();

        const futurePassTypes = passTypes.filter((i) =>
            i.periods.some((j) => today().compare(parseDate(j.start_date)) < 0)
        );

        if (startDates.length < 1) {
            return null;
        }

        return (
            <div className="activitypass-pass-rates">
                <div
                    className="activitypass-pass-rates-increases"
                    role="button"
                    tabIndex="0"
                    onClick={this.toggleOpen}
                    onKeyDown={(event) => {
                        if (
                            event.code === 'Space' ||
                            event.code === 'Enter' ||
                            event.which === '32' ||
                            event.which === '13'
                        ) {
                            event.preventDefault();
                            this.toggleOpen();
                        }
                    }}
                >
                    {isOpen ? (
                        <Icon iconName="chevron-up" />
                    ) : (
                        <Icon iconName="chevron-down" />
                    )}
                    Pass Rates - See upcoming price increases
                </div>

                {isOpen && (
                    <div className="activitypass-pass-types-table-wrapper">
                        <table className="activitypass-pass-types-table activitypass-pass-rates-table">
                            <thead>
                                <tr>
                                    <th>&nbsp;YEARLY RATES</th>
                                    {startDates.map((startDate) => (
                                        <th key={startDate}>
                                            {parseDate(startDate).year}
                                        </th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {futurePassTypes
                                    .sort(this.props.sortFn)
                                    .map((passType) => {
                                        let previousPrice = '';
                                        return (
                                            <tr key={`pass-rate-row-${passType.id}`}>
                                                <td>{passType.name}</td>
                                                {startDates.map((startDate, i) => {
                                                    const period = passType.periods.find(
                                                        ({ start_date: start }) =>
                                                            start === startDate
                                                    );
                                                    const price = period
                                                        ? getPrice(
                                                              [period],
                                                              startDate,
                                                              true
                                                          )
                                                        : previousPrice;
                                                    previousPrice = price;

                                                    const formattedPrice = period
                                                        ? price
                                                        : previousPrice;

                                                    return (
                                                        <td
                                                            key={`pass-rate-col-${passType.id}-${i}`}
                                                        >
                                                            {formattedPrice}
                                                        </td>
                                                    );
                                                })}
                                            </tr>
                                        );
                                    })}
                            </tbody>
                        </table>
                    </div>
                )}
            </div>
        );
    }
}

// cspell:ignore activitypass
